import type { ReactNode } from 'react';
import { Icon, type IconName } from '../icons/Icon.js';
import { cx } from '../utils/cx.js';

/** C-10 空状態: アイコン 24 + headline 1 行 + callout 1 行 + ボタン 1 つ（省略可）。イラストは使わない */
export function EmptyState({ icon = 'inbox', title, description, action, className }: { icon?: IconName; title: ReactNode; description?: ReactNode; action?: ReactNode; className?: string }) {
  return (
    <div className={cx('flex flex-col items-center justify-center gap-2 px-5 py-12 text-center', className)}>
      <Icon name={icon} size={24} className="text-fg-tertiary" />
      <p className="text-headline">{title}</p>
      {description ? <p className="text-callout text-fg-secondary">{description}</p> : null}
      {action ? <div className="mt-3">{action}</div> : null}
    </div>
  );
}
